import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import { showModal } from "../../../features/modal/modalSlice"
import { useEffect, useRef, useState } from "react"
import { useScrollLock } from "../../../hooks/useScrollLock"
import Button from "../../shared/button/Btn"
import styled from "styled-components"
import PageTopTitle from "../../shared/PageTopTitle"
import { clearJobListWithoutGunlukAraclar, clearJobListWithoutGunlukAraclarAndSearch, driverSearch, setControlArea, setFormActiveStep } from "../../../features/joblist/jobListSlice"
import DriverSearchContent from "../../jobList/siraSections/DriverSearchContent"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import InputPhoneFormat from "../../shared/input/new/InputPhoneFormat"
import NewUserContent from "../../jobList/siraSections/NewUserContent"
import DevamliDriverSearchContent from "../../jobList/devamliSections/DevamliDriverSearchContent"
import DevamliNewUserContent from "../../jobList/devamliSections/DevamliNewUserContent"

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 900px;
        max-height: 700px;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        padding-block: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 0 auto;
        overflow: auto;
        .error{
            font-size: 12px;
            color: var(--color-main);
            margin-top: 5px;
        }
        
        .search-section{
            width: 60%;
        }
        .sorgulama{
            padding: 10px 0px;
            width: 60%;
            margin: 0 auto;
            display: flex;
            align-items: center;
            flex-direction: column;
            border-bottom: ${({registeredUser}) => (registeredUser === true || registeredUser === false) && "2px solid"} ;
            border-color: ${({ theme }) => theme.mainBorderColor};
            .btn-container{
                display: flex;
                align-items: flex-end;
                margin-top: 30px;
            }
            .row-control{
                width: 100%;
                display: flex;
                align-items: center;
                margin-block: 15px;
                .control{
                    border: 1px solid var(--color-main);
                    color: var(--color-main);
                    padding: 10px;
                    height: 40px;
                    border-radius: 10px;
                    margin-left: 15px;
                    cursor: pointer;
                }
            }  
        }
        .title{
            font-size: var(--font-size-lg);
            font-weight: var(--font-weight-md);
        }
       .plate-title{
        margin-right: 15px;
        text-decoration: underline;
        color: var(--color-main);
        font-size: var(--font-size-sm);
        cursor: pointer;
       }
       .plate-delete{
        margin-right: 15px;
        color: var(--color-main);
        border: 1px solid var(--color-main);
        padding: 5px;
        border-radius: 10px;
        font-size: var(--font-size-sm);
        cursor: pointer;
       }
    }
    .plate{
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 63%;
        margin: 0 auto;
    }
    .relative{
        position: relative;
        .add-plate{
            position: absolute;
            top: 0;
            right: 0;
            color: var(--color-main);
            border: 1px solid var(--color-main);
            padding: 5px;
            border-radius: 10px;
            font-size: var(--font-size-sm);
            cursor: pointer;
        }
    }
    .space{
        display: flex;
        align-items: center;
    }
    .err{
        font-size: 14px;
        color: var(--color-main);
        margin-block: 10px;
    }

    @media (max-width: 1600px){
        .modal{
            height: 500px;
        }
        
    }

    @media (max-width: 1150px){
        .sorgulama{
            width: 100% !important;
            .row-control{
                justify-content: space-between;
                padding-inline: 20px;
            }
        }
        .title{
            padding-inline: 20px;
        }
    }

    @media (max-width: 850px){
        .modal{
            width: 100% !important;
            max-height: 100vh !important;
            height: 100%;
        }
        
    }
`



const AddDriverAndVehicleModal = () => {
    
    const dispatch = useDispatch()
    const location = useLocation()

    const {modalLocation } = useSelector(state => state.modal)
    const { lockScroll, unlockScroll } = useScrollLock();
    const [phoneValue, setPhoneValue] = useState("")
    const [controlPhone, setControlPhone] = useState("")

    const {controlArea, registeredUser, driverSearchData} = useSelector((state) => state.jobList)

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    const handleControl = () => {
        dispatch(setFormActiveStep(2))
        dispatch(clearJobListWithoutGunlukAraclarAndSearch())
        dispatch(driverSearch(controlArea))
    }

    useEffect(() => {
        if (controlArea) {
            const formattedPhoneNumber = (controlArea.startsWith("+90") || controlArea.startsWith("90")) ? `${controlArea}` : `90${controlArea}`;
            setPhoneValue(formattedPhoneNumber);
        }
      }, [registeredUser, controlArea]);

      useEffect(() => {
        dispatch(setControlArea(controlPhone?.slice(2)));
      }, [controlPhone])

    return (
    <ModalContainer registeredUser={registeredUser}>
    <div className="modal" onClick={(e) => { e.stopPropagation(); dispatch(handleActiveSelect(null)) }}>
        <PageTopTitle isDiffPage title={"Sürücü / Araç Ekle"}/>

        {/* //! telefon numarası sorgulama alanı */}
        <div className="sorgulama">
            <div className="row-control">
                <InputPhoneFormat inputWidth={"60%"} data={controlPhone} setData={setControlPhone} labelText="Telefon No" name="controlArea"/>
                <div onClick={handleControl} className="control">Sorgula</div> 
            </div>
            {
                registeredUser === null && 
                    <div className="btn-container">
                        <Button bgColor="#E85446" width="150px" handleClick={() => {dispatch(showModal(null)); dispatch(clearJobListWithoutGunlukAraclar())}} color="#fff">Kapat</Button>
                    </div>
            }
            
        </div>


        {/* //! sorgudan kayıtlı bir kullanıcı bulunduysa */}
        {registeredUser === true && (
            <div className="search-section" onClick={(e) =>{ e.stopPropagation(); }}>
                <DevamliDriverSearchContent data={driverSearchData} />
            </div>
        )}
        
        {/* //! sorgudan kayıtlı bir kullanıcı bulunmadıysa */}
        {/* {registeredUser === false &&
            <DevamliNewUserContent />
        }  */}
        
        
    </div>
</ModalContainer>
  )
}

export default AddDriverAndVehicleModal